import { render, staticRenderFns } from "./IndustryPage.vue?vue&type=template&id=0fa8b8a7"
import script from "./IndustryPage.vue?vue&type=script&lang=js"
export * from "./IndustryPage.vue?vue&type=script&lang=js"
import style0 from "./IndustryPage.vue?vue&type=style&index=0&id=0fa8b8a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports